<template>
    <div class="content-wraper">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="cart-table mt-60">
                        <h1>Winkelwagen</h1>
                        <hr>
                        <div
                        v-if="containsItems"
                        class="table-content table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th class="plantmore-product-remove">Verwijderen</th>
                                        <th class="plantmore-product-thumbnail">Afbeelding</th>
                                        <th class="cart-product-name">Product</th>
                                        <th>Samenstelling</th>
                                        <th class="plantmore-product-price">Aantal</th>
                                        <th class="plantmore-product-subtotal">Ontleen periode</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                    v-if="!containsItems"
                                    class="text-center">
                                        <td colspan="6">Je hebt geen producten in de winkelwagen.</td>
                                    </tr>
                                    <CartItem
                                        v-for="cartItem in cart.items"
                                        :key="cartItem.cartItemID"
                                        :cartItem="cartItem"/>
                                </tbody>
                            </table>
                        </div>
                        <div v-if="!containsItems">
                            <p>Je hebt geen producten in de winkelwagen.</p>
                        </div>
                        <div class="row mt-50">
                            <div
                            v-if="containsItems"
                            class="col-lg-12">
                                <p>Beschrijf hier kort waarom je deze producten aanvraagt<span class="text-danger">*</span> :</p>
                                <p class="coupon-input form-row-first"> <input
                                v-model="notes"
                                type="text"
                                name="notes"
                                :maxlength="max"
                                > </p>
                            </div>

                            <div class="col-lg-12">
                                <p><b>Je koos dit uitleenpunt om materiaal af te halen en terug te brengen:</b></p>
                                <ul>
                                    <li>
                                        <strong>Magazijn:</strong>
                                        <p v-html="localization.warehouseID"/>
                                    </li>
                                    <li>
                                        <strong>Adres:</strong>
                                        <p v-html="localization.address"/>
                                    </li>
                                    <li v-if="localization.openingHours">
                                        <strong>Openingstijden:</strong>
                                        <p v-html="localization.openingHours"/>
                                    </li>
                                    <li>
                                        <strong>Telefoon:</strong>
                                        <p v-html="localization.phoneNumber"/>
                                    </li>
                                    <li v-if="localization.email">
                                        <strong>E-mail:</strong>
                                        <p> <a v-bind:href="'mailto:'+localization.email">{{localization.email}}</a> </p>
                                    </li>
                                </ul>
                            </div>
                            <div
                            v-if="containsItems"
                            class="col-lg-12">
                                <hr>
                                <p>
                                <input
                                v-model="termConditions"
                                type="checkbox"
                                name="termConditions"
                                value="accept">
                                <span class="text-danger">*</span> Ik verklaar dat ik de <router-link :to="{name: 'terms'}">Algemene Voorwaarden</router-link> heb gelezen, ermee akkoord ga en deze zal naleven. </p>
                                <p class="small">Na indiening ontvang je per e-mail automatisch een kopie van je aanvraag. Heb je geen e-mail ontvangen? Contacteer ons dan via <a href="mailto:uitleendienst@faro.be">uitleendienst@faro.be</a>.</p>
                                <p class="small">Je wordt eveneens per e-mail op de hoogte gebracht als je reservering definitief is. Samen met deze bevestiging ontvang je een document dat je kunt afdrukken en meenemen naar het uitleenpunt op het afgesproken tijdstip.</p>
                            </div>
                        </div>
                        <div class="row mt-50"/>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="coupon-all">
                                    <div class="coupon">
                                        <button
                                        v-if="containsItems"
                                        class="btn btn-secondary"
                                        @click="clearCart()">
                                            Leeg winkelwagen
                                        </button>
                                    </div>
                                    <div class="coupon2">
                                        <button
                                        v-if="containsItems"
                                        :class="buttonDisabled"
                                        :disabled="!canCheckout()"
                                        class="btn btn-secondary"
                                        @click="checkout()">{{ reservationButtonText }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CartItem from './CartItem'
import CartService from '@/services/CartService.js'
import AuthorizationService from '@/services/AuthorizationService.js'
import swal from 'sweetalert'

export default {
    components: {
        CartItem
    },
    data () {
        return {
            user: {},
            notes: '',
            termConditions: false,
            localization: {},
            reservationButtonText: 'Aanvraag indienen',
            max: 250
        }
    },
    computed: {
        cart () {
            return this.$store.getters.cart
        },
        buttonDisabled () {
            return this.canCheckout() ? null : 'reservation-button-disabled'
        },
        containsItems () {
            return this.cart.items.length > 0
        }
    },
    created () {
        this.getUser()
        this.localization.warehouseID = this.$store.getters.warehouse.WarehouseID
        this.localization.address = this.$store.getters.warehouse.CUST_Address
        this.localization.openingHours = this.$store.getters.warehouse.CUST_OpeningHours
        this.localization.phoneNumber = this.$store.getters.warehouse.CUST_PhoneNumber
        this.localization.email = this.$store.getters.warehouse.CUST_Email
    },
    methods: {
        canCheckout () {
            return this.termConditions && this.notes.length > 2
        },
        getUser () {
            this.user = AuthorizationService.getUser()
        },
        async clearCart () {
            CartService.clearCart()
        },
        async checkout () {
            let acceptTermConditions = this.termConditions
            this.termConditions = false
            this.reservationButtonText = 'Aanvraag in behandeling...'
            try {
                let result = await CartService.checkout(this.notes, acceptTermConditions)
                if (result && result.reservationItems) {
                    let reservationDetails = result.reservationItems.pop()
                    if (reservationDetails.MailSuccesfullySent) {
                        swal({
                            icon: 'success',
                            text: 'Je aanvraag is geregistreerd in het systeem en een e-mail is verstuurd naar ' + this.$store.getters.user.Email + '.'
                        })
                    } else {
                        swal({
                            icon: 'warning',
                            text: 'Het versturen van de reservering-bevestiging is mislukt. De reservering is wel aangemaakt.'
                        })
                    }
                }
                this.reservationButtonText = 'Aanvraag indienen'
            } catch (error) {
                this.$route.router.go('/') // #/register?state=NotLoggedIn
            }
        },
        setTermsConditions () {
            this.termConditions = !this.termConditions
        }
    }
}
</script>

<style scoped>
.reservation-button-disabled {
    cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components/Cart/Index.vue